import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';

// The same three values the single-part UOM conversion form asks for. Zero is
// rejected as well as empty: it would satisfy "required" and then silently make
// every converted quantity nothing.
export const bulkUpsertUomConversionsSchema = () =>
  yup.object().shape({
    baseUom: yup
      .object()
      .label(t('labelBaseUom'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelBaseUom'))),
    alternateUom: yup
      .string()
      .label(t('labelAlternateUom'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelAlternateUom'))),
    multiplier: numberSchemaWithTransform()
      .label(t('labelMultiplier'))
      .moreThan(0, t('messageMultiplierMustBePositive'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelMultiplier'))),
  });
